import defaultLocales from 'globals/locales/default';
import { BillingCycleOptionItemDataProps } from './BillingCycleOptionItem/BillingCycleOptionItem';

export const getBillingCycleOptionProps = (): BillingCycleOptionItemDataProps[] => [
  {
    id: 0,
    name: defaultLocales.billMonthly,
    description: defaultLocales.billingMonthlyDescription,
  },
  {
    id: 1,
    name: defaultLocales.billYearly,
    nameSpecial: defaultLocales.billYearlySaveInfo,
    description: defaultLocales.billingYearlyDescription,
  },
];

export const getBillingCycleSpecialOption = (): BillingCycleOptionItemDataProps => ({
  id: 0,
  name: defaultLocales.billMonthly,
  nameSpecial: defaultLocales.enterprise,
  description: defaultLocales.billingSpecialDescription,
});
